<div class="d-flex">
    <div class="table-selection-left">
        <div class="table-list-header">
            <h3 class="mb-2 display-ib">Available tables</h3> 
            <div class="search-box-2"> 
                <input type="text"
                class="form-search height-50p" 
                placeholder="Search by table names" 
                (keyup)="filterTables($event)" style="height: 45px;" class="form-search search-box">
            </div>
            <button *ngIf="field?.props?.selectButtonLabel !== 'deselect'" mat-stroked-button color="primary"
                class="btn-sm syncnow-btn touch-button-add m-l-0 sabtn sabtn-1"
                [disabled]="isTemplate"
                (click)="toggleAllTableSelection('select')">
                Select all Tables
            </button>
            <button *ngIf="field?.props?.selectButtonLabel === 'deselect'" mat-stroked-button color="primary"
                class="btn-sm syncnow-btn touch-button-add m-l-0 sabtn sabtn-1"
                [disabled]="isTemplate"
                (click)="toggleAllTableSelection('deselect')">
                De-select all Tables
            </button>
        </div>
        <cdk-virtual-scroll-viewport itemSize="1" class="example-viewport-3">
            <div *cdkVirtualFor="let row of field.fieldArray.fieldGroup | filterSelectedTable: model: searchString: tableCategoryVisibilityStrategy; let idx = index;" class="virtual-scroller-item">
                <div class="example-item-4-three">
                    <div class="h5 custom-header-margin">
                        {{ (row.props.category == orphanTablesName ? orphanTablesVisibleName : row.props.category )  | showTableCategory: tableCategoryVisibilityStrategy: index: row: categorizedTables}}
                    </div>
                </div>
                <div class="d-flex items-center w-full mt-3 mb-3">
                    <div class="label-02 size-fnt tab-name-1 d-flex"> 
                        <span class="mr-2"
                            matTooltip="{{row.description}}"
                            [matTooltipClass]="{ 'tool-tip': true }">{{row.name}}</span>
                        <span class="iconsvg-question help-icon" #tooltip="matTooltip"
                            matTooltip="{{row.description}}"
                            [matTooltipClass]="{ 'tool-tip': true }"
                            (mouseenter)="$event.stopImmediatePropagation()"
                            (mouseleave)="$event.stopImmediatePropagation()"
                            (click)="tooltip.show()">
                        </span>
                        <span class="tooltip hover-tooltip tooltip-sm" [hidden]="!row.props.isFullLoadSupported"> 
                            <img class="full-load" src="./assets/images/new/full-load.svg" alt="">
                              <div class="tooltip-section tooltip-left-0 fade-in m-l-20p">
                                <div class="tooltip-body">
                                  Data is loaded into warehouse by Full Load method.<br> For
                                  more details refer to our documentation </div>
                              </div>
                        </span>
                        <span class="tooltip hover-tooltip tooltip-sm"
                            *ngIf="row?.deprecatedTable">
                            <img class="full-load in-vertical"
                                src="../../assets/images/new/deprecated.svg" alt="">
                            <div class="tooltip-section  tooltip-left-0 fade-in m-l-20p">
                                <div class="tooltip-body">
                                    Table has been deprecated </div>
                            </div>
                        </span> 
                        <span class="tooltip hover-tooltip tooltip-sm"
                            *ngIf="row.fullLoadSupported"> <img class="full-load "
                                src="../../assets/images/new/full-load.svg" alt="">
                            <div class="tooltip-section  tooltip-left-0 fade-in m-l-20p">
                                <div class="tooltip-body">
                                    Data is loaded into warehouse by Full Load method.<br> For
                                    more
                                    details refer to our documentation </div>
                            </div>
                        </span>
                    </div>
                    <button mat-stroked-button color="primary" class="add-table-btn ml-auto btn-sm syncnow-btn touch-button-add fl-right"
                        [disabled]="isTemplate"
                        (click)="selectTable(row)">
                        <span>+ Add</span>
                    </button>
                </div>
                <mat-divider></mat-divider>
            </div>
        </cdk-virtual-scroll-viewport>
    </div>
    <div class="table-selection-right">
        <div class="pl-8">
            <ng-container *ngIf="field.fieldGroup.length > 0 && !field.props.noTableSelected">
                <mat-tab-group>AMAZONVENDOR
                
                    <mat-tab label="Selected tables">
                        <!-- below html block has to be removed later on-->
                        <ng-container>
                            <div class="content px-0">
                                <div class="field-container" *ngIf="field.fieldGroup.length > 0">
                                    <ng-container *ngIf="isTemplate === true">
                                        <app-restriction></app-restriction>
                                      </ng-container>
                                    <virtual-scroller #scroll [items]="field.fieldGroup" [bufferAmount]="1">
                                        <div *ngFor="let currentField of scroll.viewPortItems" class="selected-table-viewport-item">
                                            <div  class="form-params-group-with-button">
                                                <formly-field [field]="currentField"></formly-field>
                                            </div>
                                        </div>
                                    </virtual-scroller>
                                  </div>
                            </div>
                        </ng-container>
                    </mat-tab>
                </mat-tab-group>
            </ng-container>
            <ng-container *ngIf="field.props.noTableSelected">
                <div class="no-tables"> <img src="../../assets/images/new/notables.svg"> 
                    <p class="label-03 c-f-notables">There are no tables selected, please select to proceed
                        further</p>
                </div>
            </ng-container>
        </div>
    </div>
</div>
